import React from 'react';
import {useIntl} from 'react-intl';
import InfoBox from './InfoBox';
import {can} from '../../../_common/components/Permissions';
import {useInfoBoxesContext} from '../../InfoBoxesContext';
import {subjects as S, permissionTypes as T} from '../../../_common/constants/permissionSubjects';
import styles from './styles.module.scss';

const InfoBoxes = () => {
  const intl = useIntl();
  const prefix = 'dashboard-page-info-box';
  const {
    openPriceQuotes,
    newOrders,
    inspectionsInProgress,
    inspectionsPending,
    moneyRemain,
    inspectionsCurrentWeek
  } = useInfoBoxesContext();

  return can(T.VIEW, S.DASHBOARD_PAGE) && (
    <div className={styles.infoBoxesContent}>
      <InfoBox
        label={intl.formatMessage({id: `${prefix}-price-quote-open`, defaultMessage: 'Opened price quotes'})}
        value={openPriceQuotes}
      />
      <InfoBox
        label={intl.formatMessage({id: `${prefix}-order-status-new`, defaultMessage: 'New orders'})}
        value={newOrders}
      />
      <InfoBox
        label={intl.formatMessage({id: `${prefix}-inspections-in-progress`, defaultMessage: 'Inspections in progress'})}
        value={inspectionsInProgress}
      />
      <InfoBox
        label={intl.formatMessage({id: `${prefix}-inspections-in-pending`, defaultMessage: 'Pending inspections'})}
        value={inspectionsPending}
      />
      <InfoBox
        label={intl.formatMessage({id: `${prefix}-to-be-paid`, defaultMessage: 'To be paid'})}
        value={moneyRemain}
      />
      <InfoBox
        label={intl.formatMessage({
          id: `${prefix}-inspections-current-week`,
          defaultMessage: 'Coming week inspections'
        })}
        value={inspectionsCurrentWeek}
      />
    </div>
  );
};

export default InfoBoxes;
